import React from 'react';
import { Select, MenuItem, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  useOnboardingTranslation,
  OnboardingLanguage,
  languageLabels,
} from '../../translations';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120,
  },
  select: {
    fontSize: '0.85rem',
    padding: theme.spacing(0.5, 1),
    '& .MuiSelect-select': {
      paddingTop: 6,
      paddingBottom: 6,
    },
  },
}));

export const LanguageSelector = () => {
  const classes = useStyles();
  const { language, setLanguage } = useOnboardingTranslation();

  return (
    <FormControl
      variant="outlined"
      size="small"
      className={classes.formControl}
    >
      <Select
        value={language}
        onChange={e => setLanguage(e.target.value as OnboardingLanguage)}
        className={classes.select}
      >
        {(Object.keys(languageLabels) as OnboardingLanguage[]).map(lang => (
          <MenuItem key={lang} value={lang}>
            {languageLabels[lang]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
